
export const DB_URL = 'https://vgeddymvmkuywgqx.public.blob.vercel-storage.com/real_estate_data.json';


